const httpProtocol =  location.protocol + '//';

let config = {
  apiUrl: 'mp-api.shuwen.com/api',
  accountUrl: 'account.shuwen.com',
  webUrl: location.host,
  caimiUrl: 'http://caimi.shuwen.com',
  facedetectUrl: 'http://face.shuwen.com',
  httpProtocol: httpProtocol,
  staticUrl: location.host,
  authDocs: 'http://s.newscdn.cn/media-platform-web/1.1.20/%E5%AA%92%E4%BD%93%E5%A4%A7%E8%84%91%E6%9C%BA%E6%9E%84%E5%85%A5%E9%A9%BB%E5%85%AC%E5%87%BD.docx',
  apiDocs: 'http://s.newscdn.cn/media-platform-web/1.1.20/%E5%AA%92%E4%BD%93%E5%A4%A7%E8%84%91_%E7%89%88%E6%9D%83%E7%9B%91%E6%B5%8BAPI.pdf',
  deskMail: 'business@shuwen.com'
};

if (config.webUrl === 'pre.magic.shuwen.com' && config.webUrl.indexOf('shuwen.com') > -1) {
  config.apiUrl = '118.31.70.215';
  config.accountUrl = 'pre.account.shuwen.com';
} else if ( config.webUrl !== 'magic.shuwen.com' && (config.webUrl.indexOf('test.www.shuwen.com') > -1 || config.webUrl.indexOf('test.magic.shuwen.com') > -1 || config.webUrl.indexOf('dev.magic.shuwen.com') > -1 || config.webUrl.indexOf('dev.magic.xinwen.cn') > -1)  ) {
  config.apiUrl = '118.31.70.215';
  config.accountUrl = 'test.account.shuwen.com';
}

// 兼容本地开发环境
if (location.port === '8010' || location.port === '8000') {
  config.webUrl = location.hostname + ':8000';
  config.staticUrl = location.hostname + ':8010';
}

config.indexPage = httpProtocol + config.staticUrl + '/index.html';

config.loginDirect = `${httpProtocol}${config.accountUrl}/login?redirect_url=`;
config.registerDirect = `${httpProtocol}${config.accountUrl}/register?redirect_url=`;

export default config;



// WEBPACK FOOTER //
// ./src/pages/config.js